<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="reembolso"
        :search="search"
        :sort-desc="true"
        sort-by="timeStamp"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Solicitudes reembolso</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Detalles de la solicitud</span>
                </v-card-title>

                <v-card-text class="pb-0">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="date"
                          label="FECHA DE SOLICITUD"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="name"
                          label="NOMBRE"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="phone"
                          label="TELEFONO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="email"
                          label="CORREO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="brandVehicle"
                          label="MARCA"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="subBrandVehicle"
                          label="MODELO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="plateVehicle"
                          label="PLACA"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="yearVehicle"
                          label="AÑO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="useVehicle"
                          label="USO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="typeAssistance"
                          label="TIPO DE ASISTENCIA"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="priceAssistance"
                          label="PRECIO DE LA ASISTENCIA"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="status"
                          label="STATUS DEL REEMBOLSO"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="comment"
                          label="COMETARIO"
                          outlined
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue"
                    dark
                    @click="actualizarRevision()"
                    v-if="status != 'Revición'"
                    >REVISION</v-btn
                  >
                  <v-btn
                    color="green"
                    dark
                    @click="actualizarRealizado()"
                    v-if="status != 'Pagado'"
                    >REEMBOLSO REALIZADO</v-btn
                  >
                  <v-btn
                    color="red"
                    dark
                    @click="actualizarCancelar()"
                    v-if="status != 'Cancelado'"
                    >CANCELAR REEMBOLSO</v-btn
                  >
                  <v-btn color="cancel" @click="limpiar()">CERRAR</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <span>{{ new Date(item.date).toLocaleString() }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="getColorCondicion(item.status)" dark>
            <div v-if="item.status == 'Revisión'"><span>Revisión</span></div>
            <div v-if="item.status == 'Cancelado'"><span>Cancelado</span></div>
            <div v-if="item.status == 'Pagado'"><span>Pagado</span></div>
          </v-chip>
        </template>
      </v-data-table>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import { dbDevoluciones } from "../main";
export default {
  data() {
    return {
      dialog: false,
      overlay: false,
      reembolso: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        { text: "Fecha", value: "date", sortable: false },
        { text: "Nombre", value: "name", sortable: false },
        { text: "Teléfono", value: "phone", sortable: false },
        { text: "Correo", value: "email", sortable: false },
        { text: "Comentarios", value: "comment", sortable: false },
        { text: "Status", value: "status", sortable: false },
      ],
      search: "",
      idHistory: "",
      idClient: "",
      date: "",
      name: "",
      phone: "",
      email: "",
      brandVehicle: "",
      subBrandVehicle: "",
      plateVehicle: "",
      yearVehicle: "",
      useVehicle: "",
      typeAssistance: "",
      priceAssistance: "",
      comment: "",
      status: "",
      //
      list: [],
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.overlay = true;
      me.reembolso = [];
      me.list = [];
      dbDevoluciones
        .once("value")
        .then(function (dataSnapshot) {
          dataSnapshot.forEach(function (value, index) {
            me.list.push({
              idHistory: value.key,
              idClient: value.val().idClient,
              name: value.val().name,
              phone: value.val().phone,
              email: value.val().email,
              brandVehicle: value.val().brandVehicle,
              subBrandVehicle: value.val().subBrandVehicle,
              plateVehicle: value.val().plateVehicle,
              yearVehicle: value.val().yearVehicle,
              useVehicle: value.val().useVehicle,
              typeAssistance: value.val().typeAssistance,
              priceAssistance: value.val().priceAssistance,
              comment: value.val().comment,
              date: value.val().date,
              status: value.val().status,
            });
          });
          me.reembolso = me.list;
          me.overlay = false;
        })
        .catch(function (error) {
          me.overlay = false;
          console.log("ERROR", error);
        });
    },
    actualizarRevision() {
      let me = this;
      dbDevoluciones
        .child(me.idHistory)
        .update({ status: "Revisión" })
        .then(function () {
          me.dialog = false;
          me.listar();
        })
        .catch(function (error) {
          console.log("hubo algun error", error);
        });
    },
    actualizarCancelar() {
      let me = this;
      dbDevoluciones
        .child(me.idHistory)
        .update({ status: "Cancelado" })
        .then(function () {
          me.dialog = false;
          me.listar();
        })
        .catch(function (error) {
          console.log("hubo algun error", error);
        });
    },
    actualizarRealizado() {
      let me = this;
      dbDevoluciones
        .child(me.idHistory)
        .update({ status: "Pagado" })
        .then(function () {
          me.dialog = false;
          me.listar();
        })
        .catch(function (error) {
          console.log("hubo algun error", error);
        });
    },
    verDetalles(item) {
      this.dialog = true;
      let me = this;
      me.idHistory = item.idHistory;
      me.idClient = item.idClient;
      me.date = new Date(item.date).toLocaleString();
      me.name = item.name;
      me.phone = item.phone;
      me.email = item.email;
      me.brandVehicle = item.brandVehicle;
      me.subBrandVehicle = item.subBrandVehicle;
      me.plateVehicle = item.plateVehicle;
      me.yearVehicle = item.yearVehicle;
      me.useVehicle = item.useVehicle;
      me.typeAssistance = item.typeAssistance;
      me.priceAssistance = item.priceAssistance;
      me.status = item.status;
      me.comment = item.comment;
    },
    limpiar() {
      this.dialog = false;
      this.idHistory = "";
      this.idClient = "";
      this.date = "";
      this.name = "";
      this.phone = "";
      this.email = "";
      this.comment = "";
      this.status = "";
      this.brandVehicle = "";
      this.subBrandVehicle = "";
      this.plateVehicle = "";
      this.yearVehicle = "";
      this.useVehicle = "";
      this.typeAssistance = "";
      this.priceAssistance = "";
    },
    getColorCondicion(condicion) {
      if (condicion == "Revisión") {
        return "blue";
      } else if (condicion == "Cancelado") {
        return "red";
      } else if (condicion == "Pagado") {
        return "green";
      }
    },
  },
};
</script>

<style>
</style>